import React, { useEffect, useState } from "react";
import {
  Table,
  Button,
  Modal,
  Form,
  Input,
  InputNumber,
  Select,
  Space,
  Popconfirm,
  message,
  Spin,
  Divider,
  Tag,
} from "antd";
import {
  PlusOutlined,
  SearchOutlined,
  EditOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import dayjs from "dayjs";
import { DatePicker } from "antd";

import {
  getInsentiveList,
  createInsentive,
  updateInsentive,
  deleteInsentive,
} from "../../api/transaksi/Insentive";

import { dropdownKaryawan } from "../../api/master/Karyawan";
const { Option } = Select;

const InsentifKaryawan = () => {
  const sessiData = JSON.parse(sessionStorage.getItem("user"));
  const [data, setData] = useState([]);
  const [formVisible, setFormVisible] = useState(false);
  const [form] = Form.useForm();
  const [editingData, setEditingData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [karyawanList, setKaryawanList] = useState([]);
  const [paymentStatus, setPaymentStatus] = useState("pending");

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await getInsentiveList();
      if (response.status) {
        setData(response.data);
      }
    } catch (error) {
      message.error("Gagal memuat data");
    } finally {
      setLoading(false);
    }
  };
  const fetchKaryawan = async () => {
    try {
      const result = await dropdownKaryawan();
      setKaryawanList(result.data);
    } catch (error) {
      message.error("Gagal memuat data karyawan.");
    }
  };
  useEffect(() => {
    fetchData();
    fetchKaryawan();
  }, []);

  const handleAdd = () => {
    form.resetFields();
    setEditingData(null);
    setPaymentStatus("pending");
    setFormVisible(true);
  };

  const handleEdit = (record) => {
    setEditingData(record);
    form.setFieldsValue({
      ...record,
      ins_periode: dayjs(record.ins_periode),
      ins_status_pembayaran: record.ins_status_pembayaran || "pending",
      ins_tanggal_dibayar: record.ins_tanggal_dibayar
        ? dayjs(record.ins_tanggal_dibayar)
        : null,
    });
    setPaymentStatus(record.ins_status_pembayaran || "pending");
    setFormVisible(true);
  };

  const handleDelete = async (id) => {
    setLoading(true);
    try {
      await deleteInsentive(id);
      message.success("Data berhasil dihapus");
      fetchData();
    } catch (error) {
      message.error("Gagal menghapus data");
    }
  };

  const handleFinish = async (values) => {
    setSubmitLoading(true);
    const formatted = {
      ...values,
      ins_periode: values.ins_periode.format("YYYY-MM"),
      ins_tanggal_dibayar: values.ins_tanggal_dibayar
        ? values.ins_tanggal_dibayar.format("YYYY-MM-DD")
        : null,
    };

    try {
      if (editingData) {
        const payload = {
          ins_jumlah: formatted.ins_jumlah,
          ins_keterangan: formatted.ins_keterangan,
          ins_status_pembayaran: formatted.ins_status_pembayaran,
          ins_tanggal_dibayar: formatted.ins_tanggal_dibayar,
          ins_updated_by: sessiData[0].user[0].fullname,
        };
        await updateInsentive(editingData.ins_id, payload);
        message.success("Data berhasil diperbarui");
      } else {
        const payload = {
          ...formatted,
          ins_created_by: sessiData[0].user[0].fullname,
        };
        await createInsentive(payload);
        message.success("Data berhasil ditambahkan");
      }
      fetchData();
      setFormVisible(false);
    } catch (error) {
      console.log(error);
      message.error("Gagal menyimpan data");
    } finally {
      setSubmitLoading(false);
    }
  };

  const columns = [
    {
      title: "Nama Karyawan",
      dataIndex: "nama_karyawan",
      key: "nama_karyawan",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <div style={{ padding: 8 }}>
          <Input
            placeholder="Cari nama"
            value={selectedKeys[0]}
            onChange={(e) =>
              setSelectedKeys(e.target.value ? [e.target.value] : [])
            }
            onPressEnter={confirm}
            style={{ marginBottom: 8, display: "block" }}
          />
          <Space>
            <Button
              type="primary"
              onClick={confirm}
              icon={<SearchOutlined />}
              size="small"
            >
              Cari
            </Button>
            <Button
              onClick={() => {
                clearFilters();
                confirm();
              }}
              size="small"
            >
              Reset
            </Button>
          </Space>
        </div>
      ),
      onFilter: (value, record) =>
        record.nama_karyawan?.toLowerCase().includes(value.toLowerCase()),
    },
    {
      title: "Periode",
      dataIndex: "ins_periode",
      key: "ins_periode",
      sorter: (a, b) => a.ins_periode.localeCompare(b.ins_periode),
      render: (ins_periode) =>
        ins_periode && dayjs(ins_periode).isValid()
          ? dayjs(ins_periode).locale("id").format("MMMM YYYY")
          : "-",
    },
    {
      title: "Jumlah",
      dataIndex: "ins_jumlah",
      key: "ins_jumlah",
      render: (val) => `${Number(val).toLocaleString("id-ID")}`,
      sorter: (a, b) => a.ins_jumlah - b.ins_jumlah,
    },
    {
      title: "Keterangan",
      dataIndex: "ins_keterangan",
      key: "ins_keterangan",
    },
    {
      title: "Status Pembayaran",
      dataIndex: "ins_status_pembayaran",
      filters: [
        { text: "Tidak Dibayar", value: "tidak dibayar" },
        { text: "Lunas", value: "lunas" },
        { text: "Pending", value: "pending" },
      ],
      onFilter: (value, record) => record.ins_status_pembayaran === value,
      render: (status) => {
        if (!status || status === "pending") return "-";

        const colorMap = {
          pending: "volcano",
          lunas: "blue",
          "tidak dibayar": "gray",
        };
        const labelMap = {
          pending: "Pending",
          lunas: "Lunas",
          "tidak dibayar": "Tidak Dibayar",
        };

        return (
          <Tag color={colorMap[status]}>{labelMap[status]?.toUpperCase()}</Tag>
        );
      },
    },

    {
      title: "Tanggal Pembayaran",
      dataIndex: "ins_tanggal_dibayar",
      sorter: (a, b) =>
        dayjs(a.ins_tanggal_dibayar).unix() -
        dayjs(b.ins_tanggal_dibayar).unix(),
      sortDirections: ["descend", "ascend"],
      render: (ins_tanggal_dibayar) =>
        ins_tanggal_dibayar
          ? dayjs(ins_tanggal_dibayar).format("DD/MM/YYYY")
          : "-",
    },
    {
      title: "Aksi",
      key: "aksi",
      render: (_, record) => (
        <Space>
          <Button
            type="link"
            onClick={() => handleEdit(record)}
            icon={<EditOutlined />}
          >
            Edit
          </Button>
          <Popconfirm
            title="Yakin hapus data ini?"
            onConfirm={() => handleDelete(record.ins_id)}
          >
            <Button type="link" danger icon={<DeleteOutlined />}>
              Hapus
            </Button>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <div style={{ padding: 20 }}>
      <Divider>Input Insentif / Bonus Karyawan</Divider>
      <Button
        type="primary"
        icon={<PlusOutlined />}
        onClick={handleAdd}
        style={{ marginBottom: 16 }}
      >
        Tambah Insentif/Bonus
      </Button>

      <Spin spinning={loading}>
        <Table
          scroll={{ x: "max-content" }}
          columns={columns}
          pagination={{
            pageSizeOptions: ["10", "20", "40", "60"],
            showSizeChanger: true,
            defaultPageSize: 20,
          }}
          dataSource={data}
          rowKey="ins_id"
        />
      </Spin>

      <Modal
        open={formVisible}
        title={editingData ? "Edit Insentif" : "Tambah Insentif"}
        onCancel={() => setFormVisible(false)}
        onOk={() => form.submit()}
        confirmLoading={submitLoading}
      >
        <Form form={form} layout="vertical" onFinish={handleFinish}>
          <Form.Item
            name="ins_karyawan_id"
            label="Nama Karyawan"
            rules={[{ required: true, message: "Harap pilih karyawan" }]}
          >
            <Select
              placeholder="Pilih karyawan"
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children.toLowerCase().includes(input.toLowerCase())
              }
            >
              {karyawanList.map((k) => (
                <Option key={k.emp_id_karyawan} value={k.emp_id_karyawan}>
                  {k.emp_nama}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            name="ins_periode"
            label="Periode"
            rules={[{ required: true, message: "Pilih periode" }]}
          >
            <DatePicker picker="month" style={{ width: "100%" }} />
          </Form.Item>

          <Form.Item
            name="ins_jumlah"
            label="Jumlah Insentif"
            rules={[{ required: true, message: "Masukkan jumlah" }]}
          >
            <InputNumber
              min={0}
              step={0.01}
              style={{ width: "100%" }}
              formatter={(value) =>
                value ? `Rp ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",") : ""
              }
              parser={(value) => value.replace(/Rp\s?|(,*)/g, "")}
            />
          </Form.Item>

          <Form.Item
            name="ins_keterangan"
            label="Keterangan"
            rules={[{ required: true, message: "Keterangan wajib diisi" }]}
          >
            <Input.TextArea rows={3} placeholder="Alasan pemberian insentif" />
          </Form.Item>

          <Form.Item
            name="ins_status_pembayaran"
            label="Status Pembayaran"
            rules={[{ required: true, message: "Pilih status pembayaran" }]}
          >
            <Select
              placeholder="Pilih status"
              onChange={(val) => setPaymentStatus(val)}
            >
              <Option value="pending">Pending</Option>
              <Option value="lunas">Lunas</Option>
              <Option value="tidak dibayar">Tidak Dibayar</Option>
            </Select>
          </Form.Item>

          {paymentStatus === "lunas" && (
            <Form.Item
              name="ins_tanggal_dibayar"
              label="Tanggal Dibayar"
              rules={[
                { required: true, message: "Tanggal dibayar wajib diisi" },
              ]}
            >
              <DatePicker style={{ width: "100%" }} format="YYYY-MM-DD" />
            </Form.Item>
          )}
        </Form>
      </Modal>
    </div>
  );
};

export default InsentifKaryawan;
